import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  AvailableComplianceNotifications,
  AvailableTrainingNotifications,
} from './notification.models';

export const NotificationActions = createActionGroup({
  source: 'Global Notifications',
  events: {
    'Activate Compliance Notification': props<{
      notificationType: AvailableComplianceNotifications;
    }>(),
    'Remove Compliance Notification': props<{
      notificationType: AvailableComplianceNotifications;
    }>(),
    'Activate Training Notification': props<{
      notificationType: AvailableTrainingNotifications;
    }>(),
    'Remove Training Notification': props<{
      notificationType: AvailableTrainingNotifications;
    }>(),
    'Clear Notifications': emptyProps(),
  },
});
